export class Contact {
  constructor(contactInfo) {
    if (!contactInfo) {
      this.officeNumber = null
      this.mobileNumber = null
    } else {
      this.officeNumber = contactInfo.officeNumber
        ? contactInfo.officeNumber
        : null
      this.mobileNumber = contactInfo.mobileNumber
        ? contactInfo.mobileNumber
        : null
    }
  }
  getObject() {
    return JSON.parse(JSON.stringify(this))
  }
}

export class CommunicationPreferences {
  constructor(preferenceInfo) {
    if (!preferenceInfo) {
      this.email = null
      this.phone = null
    } else {
      this.email = preferenceInfo.email ? preferenceInfo.email : null
      this.phone = preferenceInfo.phone ? preferenceInfo.phone : null
    }
  }
  getObject() {
    return JSON.parse(JSON.stringify(this))
  }
}

export class User {
  constructor(userInfo) {
    if (!userInfo) {
      this.userId = null
      this.roles = null
      this.clientId = null
      this.supplierId = null
      this.firstName = null
      this.lastName = null
      this.contact = null
      this.communicationPreferences = null
      this.travelPolicyId = null
      this.userSettings = null
      this.email = null
      this.emailConfirmed = null
      this.delegates = null
      this.delegators = null
    } else {
      this.userId = userInfo.id ? userInfo.id : null
      this.roles = userInfo.roles ? userInfo.roles : null
      this.clientId = userInfo.clientId ? userInfo.clientId : null
      this.supplierId = userInfo.supplierId ? userInfo.supplierId : null
      this.firstName = userInfo.firstName ? userInfo.firstName : null
      this.lastName = userInfo.lastName ? userInfo.lastName : null
      this.contact = userInfo.contact ? new Contact(userInfo.contact) : null
      this.communicationPreferences = userInfo.communicationPreferences
        ? new CommunicationPreferences(userInfo.communicationPreferences)
        : null
      this.travelPolicyId = userInfo.travelPolicyId
        ? userInfo.travelPolicyId
        : null
      this.email = userInfo.email ? userInfo.email : null
      this.emailConfirmed = userInfo.emailConfirmed
        ? userInfo.emailConfirmed
        : null
      this.delegates = userInfo.delegates ? userInfo.delegates : null
      this.delegators = userInfo.delegators ? userInfo.delegators : null
      this.userProperties = userInfo.userProperties
        ? userInfo.userProperties
        : null
    }
  }
  getObject() {
    return JSON.parse(JSON.stringify(this))
  }
}
